import type { KeyModifiers } from 'chessboard/model/dom/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';

export namespace Arrows {
  export namespace Plugin {
    export const Name = 'arrows';
  }
}

export const ArrowType = 'arrow';

export type ArrowParams = {
  data: ArrowData;
  type: typeof ArrowType;
};

export type Arrow = Markings.Model & ArrowParams;

export type KeyedArrow = Markings.KeyedModel & ArrowParams;

export type ArrowData = Markings.WithColor & Markings.WithOpacity & Markings.WithFromTo;

export type RawArrow = Markings.Model & RawArrowParams;

export type RawArrowData = Markings.WithFromTo & {
  keyPressed: KeyModifiers;
};

export type RawArrowParams = {
  data: RawArrowData;
  type: typeof ArrowType;
};

export type RawKeyedArrow = Markings.KeyedModel & RawArrowParams;
